<div class="container mt-4 mb-5">
  <div class="row">
    <div
      *ngIf="list !== 6"
      class="col-lg-2 mb-3 pr-3"
      style="padding-left: 0 !important"
    >
      <h4 i18n>Históricos</h4>
      <div class="gcc-menudrop dropdown-menu">
        <div *ngFor="let venda of elementos; let i = index">
          <a
            *ngIf="venda.listar"
            class="dropdown-item anchor-select"
            (click)="setPage(venda)"
          >
            {{ venda.rota.replaceAll("_", " ").replaceAll("Preco", "Preço") }}
          </a>
        </div>
        <!-- <div class="clientes-pedido-link">
          <a class="dropdown-item anchor-select" (click)="setPage({ordem: 6})">
            Clientes
          </a>
        </div> -->
      </div>
    </div>
    <div
      *ngIf="list === 2"
      class="col-lg-10"
      style="border-left: 1px solid #e5e5e5"
    >
      <div class="col-lg-12">
        <h5 i18n>Vendas no periodo</h5>
        <div>
          <form (submit)="onSubmit()" [formGroup]="formSearch">
            <div class="row">
              <div class="form-group col-9 data-col">
                <label i18n>Data</label>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  bsDaterangepicker
                  formControlName="data"
                  placement="bottom left"
                  [bsConfig]="{
                    isAnimated: true,
                    dateInputFormat: 'DD-MM-YYYY',
                    ranges: ranges
                  }"
                />
              </div>
              <div class="col-3 align-self-center">
                <button
                  type="submit"
                  class="btn btn-primary"
                  (click)="getVendas()"
                  i18n
                >
                  Filtrar
                </button>
              </div>
            </div>
          </form>
        </div>
        <table
          *ngIf="vendas.length > 0"
          class="table table-hover table-condensed table-responsive-md"
        >
          <thead>
            <tr>
              <th scope="col" i18n>Data</th>
              <th scope="col" i18n>Cliente</th>
              <th scope="col" i18n>Pedido</th>
              <th scope="col" i18n>Quantidade</th>
              <th scope="col" i18n>Status</th>
              <th scope="col" i18n>Valor</th>
              <!-- <th scope="col"></th> -->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let b of vendas">
              <td>{{ b.data }}</td>
              <td>{{ b.client }}</td>
              <td>{{ b.pedido }}</td>
              <td>{{ b.quantidade }}</td>
              <td>{{ b.status }}</td>
              <td>{{ b.valor | currency : "BRL" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div *ngIf="list === 4 && pedido" class="col-lg-9">
      <div>
        <div role="document">
          <div *ngIf="pedido" class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" i18n>Pedido #{{ pedido.id }}</h5>
              <button type="button" class="close" (click)="this.pedido = false">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" style="padding: 5px !important">
              <div class="row mt-2">
                <div class="col-sm-6 pr-0">
                  <label>{{ SITE.labelCliente }}</label
                  ><br />
                  {{ pedido.clientes[0].cliente.fantasia }} -
                  {{ pedido.clientes[0].cliente.nome }},
                  {{ pedido.clientes[0].cliente.documento }}
                </div>
                <div class="col-sm-3 pr-0">
                  <label>{{ SITE.labelFilial }}</label
                  ><br />
                  {{ pedido.filial.codigo }} - {{ pedido.filial.descricao }}
                </div>
                <div class="col-sm-2">
                  <label>{{ SITE.labelTabela }}</label
                  ><br />
                  {{ pedido.tabela.codigo }} - {{ pedido.tabela.descricao }}
                </div>
              </div>
              <hr class="mt-2 mb-2" />
              <div class="row mt-2">
                <div class="col-sm-2">
                  <label i18n>Data</label><br />
                  {{ pedido.data }}
                </div>
                <div *ngIf="pedido.dataEntrega" class="col-sm-2">
                  <label i18n>Data Entrega</label><br />
                  {{ pedido.dataEntrega }}
                </div>
                <div class="col-sm-2">
                  <label i18n>Quantidade</label><br />
                  {{ pedido.quantidade }}
                </div>
                <div class="col-sm-3">
                  <label i18n>Forma pagamento</label><br />
                  {{
                    pedido.formaPagamento === null
                      ? ""
                      : pedido.formaPagamento.codigo
                  }}
                  -
                  {{
                    pedido.formaPagamento === null
                      ? ""
                      : pedido.formaPagamento.descricao
                  }}
                </div>
                <div class="col-sm-3">
                  <label i18n>Tipo</label><br />
                  {{ pedido.tipo.tipo }} - {{ pedido.tipo.descricao }}
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-sm-6">
                  <div *ngIf="pedido.observacao">
                    <label i18n>Observações</label><br />
                    {{ pedido.observacao }}
                  </div>
                </div>
                <div class="col-sm-6 pl-0">
                  <div
                    class="row mb-1 pl-0"
                    *ngIf="this.SITE.mostraImpostoDetalhado"
                  >
                    <div class="col-8 text-right pl-0">Subtotal:</div>
                    <div class="col-4 pl-0">
                      {{ pedido.subtotal | currency : "BRL" }}
                    </div>
                  </div>
                  <div
                    *ngIf="pedido.acrescimo"
                    class="row mb-1 pl-0"
                    style="color: red"
                  >
                    <div class="col-8 text-right" i18n>+ Acréscimos:</div>
                    <div class="col-4">
                      <span>{{ pedido.acrescimo | currency : "BRL" }}</span>
                    </div>
                  </div>
                  <div
                    *ngIf="pedido.desconto"
                    class="row mb-1 pl-0"
                    style="color: blue"
                  >
                    <div class="col-8 text-right">- Descontos:</div>
                    <div class="col-4">
                      <span>{{ pedido.desconto | currency : "BRL" }}</span>
                    </div>
                  </div>
                  <div
                    *ngIf="pedido.impostos && this.SITE.mostraImpostoDetalhado"
                    class="row mb-1 pl-0"
                    style="color: red"
                  >
                    <div class="col-8 text-right" i18n>+ Impostos:</div>
                    <div class="col-4">
                      <span>{{ pedido.impostos | currency : "BRL" }}</span>
                    </div>
                  </div>
                  <div
                    *ngIf="pedido.freteValor"
                    class="row mb-1"
                    style="color: red"
                  >
                    <div class="col-8 text-right" i18n>+ Frete:</div>
                    <div class="col-4">
                      <span>{{ pedido.freteValor | currency : "BRL" }}</span>
                    </div>
                  </div>
                  <div class="row mb-1 pl-0">
                    <div class="col-8 text-right pl-0" i18n>Valor total:</div>
                    <div
                      class="col-4 pl-0"
                      style="color: green; font-weight: bold"
                    >
                      {{ pedido.total | currency : "BRL" }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-sm-5"></div>
                <div class="col-sm-7"></div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="mt-2">
                    <div
                      *ngFor="let p of agruparPorProdutoReferencia(orderItens)"
                      class="table-responsive"
                    >
                      <table
                        class="table table-hover table-condensed table-striped table-sm table-responsive-xs"
                      >
                        <thead class="table-head">
                          <tr>
                            <th colspan="5" style="font-size: 14px">
                              {{ p.produtoReferencia + " - " + p.descricao }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td class="text-center">COR</td>
                            <td class="text-center">TAMANHO</td>
                            <!-- <td class="text-center">ESTAMPA</td> -->
                            <td class="text-center">QTDE</td>
                            <td class="text-center">PREÇO</td>
                            <td class="text-center">TOTAL</td>
                          </tr>
                          <tr *ngFor="let i of p.itens">
                            <td class="text-center">{{ i.corDescricao }}</td>
                            <td class="text-center">{{ i.tamanho }}</td>
                            <!-- <td class="text-center">{{i.estampaDescricao}}</td> -->
                            <td class="text-center">{{ i.quantidade }}</td>
                            <td class="text-center">
                              R$ {{ i.preco | currency : "BRL" : "" }}
                            </td>
                            <td class="text-center">
                              R$ {{ i.total | currency : "BRL" : "" }}
                            </td>
                          </tr>
                          <tr>
                            <td class="text-center"></td>
                            <!-- <td class="text-center"></td> -->
                            <td class="text-center"></td>
                            <td class="text-center">
                              <b>
                                {{ sumQtd(p.itens) }}
                              </b>
                            </td>
                            <td class="text-center"></td>
                            <td class="text-center">
                              <b>
                                R$
                                {{ sumPrc(p.itens) | currency : "BRL" : "" }}
                              </b>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="list === 4 && !pedido"
      class="col-lg-9"
      style="border-left: 1px solid #e5e5e5"
    >
      <div class="row justify-content-between">
        <div class="col-11">
          <h5 i18n>Pedidos pendentes de pagamento</h5>
        </div>
      </div>
      <form autocomplete="off" [formGroup]="formSearch">
        <div class="row">
          <div class="col-lg-3">
            <div class="form-group">
              <label i18n>Data de finalização</label>
              <input
                type="text"
                class="form-control form-control-sm"
                bsDaterangepicker
                formControlName="data"
                placement="bottom left"
                [bsConfig]="{
                  isAnimated: true,
                  dateInputFormat: 'DD-MM-YYYY',
                  ranges: ranges
                }"
              />
            </div>
          </div>
          <div class="form-group col-4">
            <label i18n>Cliente</label>
            <input
              [(ngModel)]="typingCliente"
              [ngModelOptions]="{ standalone: true }"
              [typeaheadAsync]="true"
              [typeahead]="clientes"
              typeaheadOptionField="{{ 'nome' }}"
              isAnimated="true"
              (typeaheadOnSelect)="onSelectCliente($event)"
              (typeaheadNoResults)="typeaheadNoResults($event)"
              id="cliente"
              autocomplete="off"
              class="form-control form-control-sm"
            />
          </div>
          <div class="form-group col-3">
            <label i18n>Nº do pedido</label>
            <input
              name="pedido"
              formControlName="pedido"
              type="text"
              maxlength="255"
              class="form-control"
            />
          </div>
          <div class="form-group col-3">
            <label i18n>Usuário</label>

            <input
              [(ngModel)]="typingUsuario"
              [ngModelOptions]="{ standalone: true }"
              [typeaheadAsync]="true"
              [typeahead]="usuarios"
              typeaheadOptionField="nome"
              isAnimated="true"
              (typeaheadOnSelect)="onSelectUsuario($event)"
              (typeaheadNoResults)="typeaheadNoResultsUsuario($event)"
              id="usuario"
              autocomplete="off"
              class="form-control form-control-sm"
            />
          </div>
          <div class="form-group col-3">
            <label>Status</label>
            <select
              class="form-control"
              id="status"
              name="status"
              formControlName="status"
            >
              <option value="TODOS" i18n>Todos</option>
              <option value="PAGO" i18n>Pago</option>
              <!-- <option value="EM_ANDAMENTO" i18n>Em Andamento</option> -->
              <option value="EM_APROVACAO" i18n>Aguardando Aprovação</option>
              <option value="EM_INTEGRACAO" i18n>Aguardando Integração</option>
            </select>
          </div>
          <div class="col-1 align-self-center">
            <button (click)="getPedidos()" class="btn btn-primary" i18n>
              Filtrar
            </button>
          </div>
          <div class="col-2 align-self-center">
            <button
              *ngIf="selectedIds.length > 0"
              (click)="aproveAll()"
              class="btn btn-primary"
              i18n
            >
              Aprovar Pedidos
            </button>
          </div>
        </div>
      </form>
      <div class="row" style="padding-left: 15px" *ngIf="pedidos.length > 0">
        <table class="table table-hover table-condensed table-responsive-md">
          <thead>
            <tr>
              <th scope="col">
                <input
                  class="form-control"
                  type="checkbox"
                  id="selectAll"
                  (change)="toggleSelectAll($event.target.checked)"
                />
              </th>
              <th scope="col" i18n>Pedido</th>
              <th scope="col" i18n>Código</th>
              <!-- <th scope="col" i18n>Usuário</th> -->
              <th scope="col" i18n>Cliente</th>
              <th scope="col" i18n>Empresa</th>
              <th scope="col" i18n>Tabela</th>
              <th scope="col" i18n>Status de pagamento</th>
              <th scope="col" i18n>Crédito</th>
              <th scope="col" i18n>Itens</th>
              <th scope="col" i18n>R$&nbsp;Valor</th>
              <th scope="col" i18n></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let b of pedidos">
              <td>
                <input
                  [disabled]="!disableCheckbox(b)"
                  class="form-control"
                  type="checkbox"
                  id="flexCheckDefault"
                  [checked]="isSelected(b.numero_pedido)"
                  (change)="toggleSelection($event, b.numero_pedido)"
                />
              </td>
              <td>{{ b.numero_pedido }}</td>
              <td>{{ b.codigo_pedido }}</td>
              <!-- <td>{{ b.usuario.id + " - " + b.usuario.nome }}</td> -->
              <td>{{ b.nome_cliente }}</td>
              <td>{{ b.nome_filial }}</td>
              <td>{{ b.nome_tabela }}</td>
              <td>{{ replaceString(b.status_pagamento) }}</td>
              <td class="money-green">
                {{ b.limite_credito | currency : "BRL" : "" }}
              </td>
              <td>{{ b.quantidade }}</td>
              <td class="money-green">
                {{ b.total | currency : "BRL" : "" }}
              </td>
              <td class="text-center align-middle">
                <div class="btn-group" role="toolbar">
                  <button
                    title="Visualizar"
                    style="border-radius: 4px"
                    class="btn btn-outline-primary"
                    (click)="showPedidoFinalizado(b)"
                  >
                    <mat-icon>visibility</mat-icon>
                  </button>
                  <button
                    *ngIf="selectedIds.length < 1"
                    title="Aprovar"
                    style="border-radius: 4px"
                    class="btn btn-outline-primary ml-2 aprova-pedido-btn"
                    (click)="getIdPedido(b)"
                  >
                    <mat-icon>approval</mat-icon>
                  </button>
                  <button
                    *ngIf="
                      b.status_pagamento === 'pre_pago' ||
                      b.status_pagamento === 'pendente'
                    "
                    (click)="consultaPix(b.numero_pedido)"
                    data-toggle="modal"
                    title="Pagar"
                    style="border-radius: 4px"
                    class="btn btn-outline-primary ml-2"
                  >
                    <mat-icon>payments</mat-icon>
                  </button>
                  <button
                    id="desconto-btn"
                    (click)="aplicaDesconto(b.numero_pedido)"
                    data-toggle="modal"
                    title="desconto"
                    style="border-radius: 4px"
                    class="btn btn-outline-primary ml-2"
                  >
                    <mat-icon>percent</mat-icon>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div *ngIf="pageable && pedidos.length > 0" class="row">
        <div class="col-lg-4 pl-0">
          <label i18n>Página {{ pageNumber }} de {{ pagTotais }}</label>
        </div>
        <div class="col-lg-4">
          <pagination
            [totalItems]="totalElements"
            [maxSize]="5"
            [disabled]="false"
            [(ngModel)]="pageNumber"
            (pageChanged)="pageOrderChanged($event)"
            previousText="&lsaquo;"
            nextText="&rsaquo;"
          >
          </pagination>
        </div>
        <div class="col-lg-4 text-right pr-0">
          <label i18n>{{ totalElements }} registros encontrados</label>
        </div>
      </div>
    </div>
    <div
      *ngIf="list == 3"
      class="col-lg-9"
      style="border-left: 1px solid #e5e5e5"
    >
      <div class="col-lg-12">
        <h5 i18n>Estoque</h5>
        <div>
          <form (submit)="onSubmit()" [formGroup]="formSearch">
            <div class="row">
              <div class="form-group col-4 pl-0">
                <label i18n>SKU</label>
                <input
                  formControlName="sku"
                  class="form-control"
                  type="text"
                  placeholder="SKU"
                />
              </div>
              <div class="form-group col-3">
                <label i18n>Filial</label>
                <select
                  id="filial"
                  formControlName="filial"
                  class="form-control"
                >
                  <option value=""></option>
                  <option *ngFor="let f of filiais" value="{{ f.id }}">
                    {{ f.codigo }} - {{ f.descricao }}
                  </option>
                </select>
              </div>
              <div class="form-group col-3">
                <label i18n>Tipo</label>
                <select id="tipo" formControlName="tipo" class="form-control">
                  <option value="analitico" i18n>Analítico</option>
                  <option value="sintetico" i18n>Sintético</option>
                </select>
              </div>
              <div class="col-1 align-self-center">
                <button
                  type="submit"
                  class="btn btn-primary"
                  (click)="getEstoque(true)"
                  i18n
                >
                  Filtrar
                </button>
              </div>
              <div class="col-1 align-self-center" *ngIf="estoque.length > 0">
                <button
                  type="submit"
                  class="btn float-right"
                  style="background-color: #006400; color: white"
                  (click)="exportToExcel('planilha_estoque')"
                  i18n
                >
                  Exportar
                </button>
              </div>
            </div>
          </form>
        </div>
        <table
          class="table table-hover table-condensed table-responsive-md"
          *ngIf="pageable && estoque.length > 0"
        >
          <thead>
            <tr>
              <th scope="col" i18n>SKU</th>
              <th scope="col" i18n>Filial</th>
              <th scope="col" i18n>Referência</th>
              <th scope="col" i18n>Descrição</th>
              <th scope="col" i18n *ngIf="tipo === 'analitico'">Cor</th>
              <th scope="col" i18n *ngIf="tipo === 'analitico'">Tamanho</th>
              <th scope="col" i18n>Estoque</th>
              <th scope="col" i18n>Disponível</th>
              <th scope="col" i18n>Dimensões</th>
              <th scope="col" i18n>Ativo</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let b of estoque">
              <td>{{ b.barra }}</td>
              <td>{{ b.filial }}</td>
              <td>{{ b.referencia }}</td>
              <td>{{ b.descricao }}</td>
              <td *ngIf="tipo === 'analitico'">{{ b.cor }}</td>
              <td *ngIf="tipo === 'analitico'">{{ b.tamanho }}</td>
              <td>{{ b.estoque }}</td>
              <td>{{ b.disponivel }}</td>
              <td>{{ b.dimensoes }}</td>
              <td class="ativo-td" *ngIf="b.ativo; else elseBlock">
                <i class="icofont-check ativo-td"></i>
              </td>
              <ng-template #elseBlock>
                <td class="ativo-td">x</td>
              </ng-template>
            </tr>
          </tbody>
        </table>
      </div>
      <div *ngIf="pageable" class="row">
        <div class="col-lg-4 pl-0">
          <label i18n>Página {{ pageNumber }} de {{ pagTotais }}</label>
        </div>
        <div class="col-lg-4">
          <pagination
            [totalItems]="totalElements"
            [itemsPerPage]="50"
            [maxSize]="5"
            [disabled]="false"
            [(ngModel)]="pageNumber"
            (pageChanged)="pageChanged($event)"
            previousText="&lsaquo;"
            nextText="&rsaquo;"
          >
          </pagination>
        </div>
        <div class="col-lg-4 text-right pr-0">
          <label i18n>{{ totalElements }} registros encontrados</label>
        </div>
      </div>
    </div>
    <div *ngIf="list === 6" class="col-lg-12">
      <div>
        <div role="document">
          <div class="modal-content">
            <div class="modal-header align-items-top">
              <div class="col-7">
                <div class="row pt-2">
                  <div class="col-6">
                    <div class="form-group mb-1">
                      <label i18n>Código</label><br />
                      <b>{{ clienteSelecionadoPedidos.codigo }}</b>
                    </div>
                    <div
                      class="form-group mb-1"
                      *ngIf="clienteSelecionadoPedidos.limite_credito !== null"
                    >
                      <label i18n>limite de crédito</label><br />
                      <b
                        *ngIf="
                          clienteSelecionadoPedidos.limite_credito !== null
                        "
                        >R$
                        {{
                          clienteSelecionadoPedidos.limite_credito
                            | currency : "BRL" : ""
                        }}</b
                      >
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group mb-1">
                      <label i18n>Nome</label><br />
                      {{ clienteSelecionadoPedidos.nome }}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label i18n>Fantasia</label><br />
                      {{ clienteSelecionadoPedidos.fantasia }}
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label i18n>CNPJ</label><br />
                      {{ clienteSelecionadoPedidos.cnpj }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-4 pl-3">
                <div class="form-group mb-0">
                  <label i18n>Cliente</label>
                  <input
                    [(ngModel)]="typingCliente"
                    [ngModelOptions]="{ standalone: true }"
                    [typeaheadAsync]="true"
                    [typeahead]="clientes"
                    typeaheadOptionField="{{ 'nome' }}"
                    isAnimated="true"
                    (typeaheadOnSelect)="onSelectClientePedidos($event)"
                    (typeaheadNoResults)="typeaheadNoResultsPedidos($event)"
                    id="cliente2"
                    autocomplete="off"
                    class="form-control form-control-sm"
                  />
                </div>
                <div class="form-group data-filtro-historico mb-0">
                  <label i18n>Data</label>
                  <div
                    class="d-flex flex-row align-items-top justify-content-between"
                  >
                    <div class="col-10 p-0">
                      <input
                        type="text"
                        [(ngModel)]="dataCliente"
                        class="form-control form-control-sm"
                        bsDaterangepicker
                        placement="bottom left"
                        [bsConfig]="{
                          isAnimated: true,
                          dateInputFormat: 'DD-MM-YYYY',
                          ranges: ranges
                        }"
                      />
                    </div>
                    <div class="col">
                      <button
                        type="submit"
                        class="btn btn-primary ml-auto"
                        (click)="onFilterPedidos()"
                        i18n
                      >
                        Filtrar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-1">
                <button type="button" class="close" (click)="this.list = 0">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="modal-body">
              <div class="row"></div>
              <div class="row">
                <div class="col-2 mb-3 pr-3">
                  <div
                    class="gcc-menudrop dropdown-menu"
                    style="border: none; border-right: 1px solid #e5e5e5"
                  >
                    <div>
                      <a
                        [class]="
                          pageCliente === 1
                            ? 'anchor-selected dropdown-item anchor-select'
                            : 'dropdown-item anchor-select'
                        "
                        (click)="setPageCliente(1)"
                      >
                        Pedidos
                      </a>
                    </div>
                    <div>
                      <a
                        [class]="
                          pageCliente === 2
                            ? 'anchor-selected dropdown-item anchor-select'
                            : 'dropdown-item anchor-select'
                        "
                        (click)="setPageCliente(2)"
                      >
                        Notas
                      </a>
                    </div>
                    <div>
                      <a
                        [class]="
                          pageCliente === 3
                            ? 'anchor-selected dropdown-item anchor-select'
                            : 'dropdown-item anchor-select'
                        "
                        (click)="setPageCliente(3)"
                      >
                        Boletos
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-10"
                  *ngIf="pageCliente === 1 && clienteSelecionado > 0"
                >
                  <table
                    class="table table-hover table-condensed table-responsive-md"
                  >
                    <thead>
                      <tr>
                        <!-- <th scope="col" i18n>Status</th> -->
                        <th scope="col" i18n>Data de emissão</th>
                        <th scope="col" i18n>Número pedido</th>
                        <!-- <th scope="col" i18n>Pedido</th> -->
                        <th scope="col" i18n>Qtd</th>
                        <th scope="col" i18n>Valor</th>
                        <th scope="col" i18n>Qtd entregue</th>
                        <th scope="col" i18n>Valor entregue</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let b of pedidosCliente">
                        <!-- <td>{{ b.status }}</td> -->
                        <td>
                          {{
                            b.data_emissao.slice(-2) +
                              "/" +
                              b.data_emissao.slice(5, 7) +
                              "/" +
                              b.data_emissao.slice(0, 4)
                          }}
                        </td>
                        <td>{{ b.numero_pedido }}</td>
                        <!-- <td>{{ b.pedido_id}}</td> -->
                        <td>{{ b.quantidade }}</td>
                        <td>{{ b.valor_pedido | currency : "BRL" }}</td>
                        <td>{{ b.quantidade_entregue }}</td>
                        <td>{{ b.valor_entregue | currency : "BRL" }}</td>
                        <td>
                          <div class="row">
                            <button
                              (click)="redirectToRastreio(b)"
                              class="btn btn-outline-primary mr-1 rastreio-btn"
                              title="Rastreio"
                              i18n-title
                            >
                              <mat-icon>local_shipping</mat-icon>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div
                    class="row"
                    *ngIf="pageCliente === 1 && clienteSelecionado > 0"
                  >
                    <div class="col-lg-4 pl-0">
                      <label i18n
                        >Página {{ pageNumberNotas }} de
                        {{ pagTotaisErp }}</label
                      >
                    </div>
                    <div class="col-lg-4">
                      <pagination
                        [totalItems]="totalElementsErp"
                        [maxSize]="5"
                        [itemsPerPage]="20"
                        [disabled]="false"
                        [(ngModel)]="pageNumberNotas"
                        (pageChanged)="changePageERP($event)"
                        previousText="&lsaquo;"
                        nextText="&rsaquo;"
                      >
                      </pagination>
                    </div>
                    <div class="col-lg-4 text-right pr-0">
                      <label i18n
                        >{{ totalElementsErp }} registros encontrados</label
                      >
                    </div>
                  </div>
                </div>
                <div
                  class="col-10"
                  *ngIf="pageCliente === 2 && clienteSelecionado > 0"
                >
                  <table
                    class="table table-hover table-condensed table-responsive-md"
                  >
                    <thead>
                      <tr>
                        <th scope="col" i18n>Data de emissão</th>
                        <th scope="col" i18n>Nota</th>
                        <th scope="col" i18n>Série</th>
                        <!-- <th scope="col" i18n>Cliente</th> -->
                        <th scope="col" i18n>Chave</th>
                        <th scope="col" i18n>Status</th>
                        <th scope="col" i18n>Quantidade</th>
                        <th scope="col" i18n>Valor produtos</th>
                        <th scope="col" i18n>Valor</th>
                        <th scope="col" i18n></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let b of notasPedido">
                        <td>{{ b.data_emissao_nf | date : "dd-MM-yyyy" }}</td>
                        <td>{{ b.nota }}</td>
                        <td>{{ b.serie }}</td>
                        <!-- <td>{{ b.cliente }}</td> -->
                        <td>{{ b.chave_nfe }}</td>
                        <td>{{ b.status }}</td>
                        <td>{{ b.quantidade }}</td>
                        <td>{{ b.valor_produtos | currency : "BRL" }}</td>
                        <td>{{ b.valor_nota | currency : "BRL" }}</td>
                        <td>
                          <div
                            *ngIf="
                              b.documentos && b.documentos.length > 1;
                              else elseBlockPrint1
                            "
                            class="dropdown nfe-btn"
                          >
                            <button
                              class="btn btn-outline-primary dropdown-toggle buttonMiddle"
                              style="min-height: -webkit-fill-available"
                              id="dropdownMenuLink"
                              data-toggle="dropdown"
                              title="Nota fiscal"
                              i18n-title
                            >
                              <img
                                src="assets/nfe-icon.svg"
                                class="normal-icon"
                                width="24"
                              />
                              <img
                                src="assets/nfe-icon-hover.svg"
                                class="hover-icon"
                                width="24"
                              />
                            </button>
                            <div
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuLink"
                              style="cursor: pointer"
                            >
                              <a
                                *ngFor="let p of b.documentos"
                                (click)="printNota(p)"
                                class="dropdown-item"
                              >
                                {{ p.numero_nota }} -
                                {{ p.tipo }}
                              </a>
                            </div>
                          </div>
                          <ng-template #elseBlockPrint1>
                            <button
                              class="btn btn-outline-primary buttonMiddle nfe-btn"
                              title="Nota fiscal"
                              i18n-title
                              [class.spinner]="loadPdf"
                              [disabled]="!b.documentos || loadPdf"
                              (click)="printNota(b.documentos[0])"
                            >
                              <img
                                src="assets/nfe-icon.svg"
                                class="normal-icon"
                                width="24"
                              />
                              <img
                                src="assets/nfe-icon-hover.svg"
                                class="hover-icon"
                                width="24"
                              />
                            </button>
                          </ng-template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div
                    *ngIf="pageCliente === 2 && clienteSelecionado > 0"
                    class="row"
                  >
                    <div class="col-lg-4 pl-0">
                      <label i18n
                        >Página {{ pageNumberNotas }} de
                        {{ pagTotaisNotas }}</label
                      >
                    </div>
                    <div class="col-lg-4">
                      <pagination
                        [totalItems]="totalElementsNotas"
                        [maxSize]="5"
                        [itemsPerPage]="20"
                        [disabled]="false"
                        [(ngModel)]="pageNumberNotas"
                        (pageChanged)="changePageNotas($event)"
                        previousText="&lsaquo;"
                        nextText="&rsaquo;"
                      >
                      </pagination>
                    </div>
                    <div class="col-lg-4 text-right pr-0">
                      <label i18n
                        >{{ totalElements }} registros encontrados</label
                      >
                    </div>
                  </div>
                </div>
                <div class="col-10" *ngIf="pageCliente === 3">
                  <table
                    class="table table-hover table-condensed table-responsive-md"
                  >
                    <thead>
                      <tr>
                        <th scope="col" i18n>Sacado</th>
                        <th scope="col" i18n>CNPJ</th>
                        <th scope="col" i18n>Número</th>
                        <th scope="col" i18n>Vencimento</th>
                        <th scope="col" i18n>Documento</th>
                        <th scope="col" i18n>R$ Valor</th>
                        <th scope="col" i18n></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let b of boletosCliente">
                        <td>{{ b.sacadoNome }}</td>
                        <td>{{ b.sacadoCnpj }}</td>
                        <td>{{ b.nossoNumero }}</td>
                        <td>{{ b.dataVencimento | dateBRA }}</td>
                        <td>{{ b.numeroDocumento }}</td>
                        <td class="money-green">
                          {{ b.valorBoleto | currency : "BRL" : "" }}
                        </td>
                        <td class="text-center align-middle">
                          <button
                            (click)="printBoletoPdf(b)"
                            data-toggle="modal"
                            data-target="#boletoModal"
                            title="Mostrar Boleto"
                            class="btn btn-outline-primary"
                          >
                            <i class="icofont-search-document"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div
                    *ngIf="pageCliente === 3 && clienteSelecionado > 0"
                    class="row"
                  >
                    <div class="col-lg-4 pl-0">
                      <label i18n
                        >Página {{ pageNumberBoletos }} de
                        {{ pagTotaisBoletos }}</label
                      >
                    </div>
                    <div class="col-lg-4">
                      <pagination
                        [totalItems]="totalElementsBoletos"
                        [maxSize]="5"
                        [itemsPerPage]="20"
                        [disabled]="false"
                        [(ngModel)]="pageNumberBoletos"
                        (pageChanged)="changePageBoletos($event)"
                        previousText="&lsaquo;"
                        nextText="&rsaquo;"
                      >
                      </pagination>
                    </div>
                    <div class="col-lg-4 text-right pr-0">
                      <label i18n
                        >{{ totalElements }} registros encontrados</label
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="list == 5"
      class="col-lg-9"
      style="border-left: 1px solid #e5e5e5"
    >
      <div class="col-lg-12">
        <h5 i18n>Preços</h5>
        <div>
          <form (submit)="onSubmit()" [formGroup]="formSearch">
            <div class="row">
              <div class="form-group col-7 pl-0">
                <label i18n>Produto</label>
                <input
                  id="produto"
                  formControlName="produto"
                  class="form-control"
                />
              </div>
              <div class="form-group col-3">
                <label i18n>Tabela</label>
                <select
                  id="tabela"
                  formControlName="tabela"
                  class="form-control"
                >
                  <option value=""></option>
                  <option *ngFor="let t of tabelas" value="{{ t.id }}">
                    {{ t.codigo }} - {{ t.descricao }}
                  </option>
                </select>
              </div>
              <div class="col-1 align-self-center">
                <button
                  type="submit"
                  class="btn btn-primary"
                  (click)="getPreco(true)"
                  i18n
                >
                  Filtrar
                </button>
              </div>
              <div class="col-1 align-self-center">
                <button
                  type="submit"
                  *ngIf="precos.length > 0"
                  class="btn float-right"
                  style="background-color: #006400; color: white"
                  (click)="exportPriceToExcel('planilha_preco')"
                  i18n
                >
                  Exportar
                </button>
              </div>
            </div>
          </form>
        </div>
        <table
          class="table table-hover table-condensed table-responsive-md"
          *ngIf="pageable && precos.length > 0"
        >
          <thead>
            <tr>
              <th scope="col" i18n>Código</th>
              <th scope="col" i18n>Tabela</th>
              <th scope="col" i18n>Referência</th>
              <th scope="col" i18n>Sku</th>
              <th scope="col" i18n>Produto</th>
              <th scope="col" i18n>Cor</th>
              <th scope="col" i18n>Preço</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let b of precos">
              <td>{{ b.cod_tabela }}</td>
              <td>{{ b.desc_tabela }}</td>
              <td>{{ b.referencia }}</td>
              <td>{{ b.sku }}</td>
              <td>{{ b.produto }}</td>
              <td>{{ b.cor }}</td>
              <td>{{ b.preco | currency : "BRL" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div *ngIf="pageable" class="row">
        <div class="col-lg-4 pl-0">
          <label i18n>Página {{ pageNumber }} de {{ pagTotais }}</label>
        </div>
        <div class="col-lg-4">
          <pagination
            [totalItems]="totalElements"
            [itemsPerPage]="50"
            [maxSize]="5"
            [disabled]="false"
            [(ngModel)]="pageNumber"
            (pageChanged)="pageChangedPreco($event)"
            previousText="&lsaquo;"
            nextText="&rsaquo;"
          >
          </pagination>
        </div>
        <div class="col-lg-4 text-right pr-0">
          <label i18n>{{ totalElements }} registros encontrados</label>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="confirmAprovaModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="confirmAprovaModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>
          Deseja realmente aprovar o pedido {{ this.nome }}?<br />
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <span><b>Representante: </b> {{ nomeRepresentante }}</span
        ><br />
        <span><b>Forma de pagamento: </b> {{ formaPagamento }}</span>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          data-dismiss="modal"
          (click)="devolveParaDigitacao(nome)"
          class="btn btn-secondary btn-devolve-digitacao"
          i18n
        >
          Devolver para digitação
        </button>
        <button
          type="button"
          data-dismiss="modal"
          (click)="aprovaPedido(nome)"
          class="btn btn-outline-primary"
          i18n
        >
          Aprovar
        </button>
        <button
          type="button"
          data-dismiss="modal"
          (click)="reprovaPedido(nome)"
          class="btn btn-primary"
          i18n
        >
          Reprovar
        </button>
        <button
          type="button"
          data-dismiss="modal"
          class="btn"
          style="background: black; color: white"
          i18n
        >
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="pixModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="pixModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>QR code de pagamento</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body col mx-auto text-center">
        <img width="200" height="200" [src]="getSafeImageUrl()" />

        <span class="copy-btn" (click)="copyLink(qrCode.codigo_qrcode)">
          {{ qrCode.codigo_qrcode ? qrCode.codigo_qrcode : "" }} </span
        ><br />
        <button
          class="btn btn-success mt-2"
          (click)="copyLink(qrCode.codigo_qrcode)"
          i18n
        >
          Copiar código
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="descontoModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="descontoModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>Aplicar Desconto</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body col mx-auto text-center">
        <input
          [value]="descontoValor"
          type="number"
          class="form-control"
          (change)="valorDesconto($event.target.value)"
        />
        <br />
        <button
          class="btn btn-success mt-2"
          i18n
          (click)="desconto()"
          data-dismiss="modal"
          aria-label="Close"
        >
          Aplicar Desconto
        </button>
      </div>
    </div>
  </div>
</div>
